export default class sectionComponent {
    constructor(el){
        this.element = el;
        el.component = this;
    }
    isOnViewPort(visible){
        throw new Error('isOnViewPort not implemented.');
    }
    isWithinViewPort(visible){
        throw new Error('isWithinViewPort not implemented.');
    }
}